export function firstValueOrUndefined<V>(val: V[] | undefined | null): V | undefined {
  if (val && val.length > 0) {
    return val[0];
  }
  return undefined;
}

export function firstValueOrNull<V>(val: V[] | null | undefined): V | null {
  if (val && val.length > 0) {
    return val[0];
  }
  return null;
}

export function transformToShallowObject<V>(val: { id: string; fields: V }): { id: string } & V {
  const fieldsFlattened = { ...val.fields };
  const output = Object.assign({ id: val.id }, fieldsFlattened);
  return output;
}
